import { useRef, useState } from 'react';
import React from "react";
import HeroBanner from "../../base/HeroBanner/HeroBanner";
import SinglePage from "../SinglePage/SinglePage";
import { ColumnsWrapper, Column, Container, StyledMenuItem, StyledMultilineTextField, StyledTextField, StyledFormControlLabel, StyledFormControl, StyledInputLabel, StyledSelect, HighlightLink } from "./styles";
import TopicIntro from "../../base/Topic/TopicIntro";
import { Checkbox, SelectChangeEvent } from "@mui/material";
import { smoothScrollTo } from "../../functionallity/smoothScrollTo";
import emailjs from 'emailjs-com';
import { SubmitInput } from '../../base/Buttons/SubmitButton/styles';
import MessageConfirmed from './MessageConfirmed/MessageConfirmed';
import { Link } from 'react-router-dom';

const Contact = () => {
  const topicIntroRef = useRef<HTMLDivElement>(null);
  const [salutation, setSalutation] = useState('');
  const [privacyChecked, setPrivacyChecked] = useState(false);
  const [isEmailSent, setIsEmailSent] = useState(false); 

  const scrollToTopicIntro = () => {
    if (topicIntroRef.current) {
      smoothScrollTo(topicIntroRef.current, 2000);
    }
  };

  const handleSalutationChange = (event: SelectChangeEvent<unknown>) => {
    setSalutation(event.target.value as string);
  };

  const handlePrivacyChange = () => {
    setPrivacyChecked(!privacyChecked);
  };

  const sendEmail = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    try {
      await emailjs.sendForm('service_fgnqglb', 'template_mqj9eot', e.target as HTMLFormElement, 'NXL0M06AdZffMy7UZ');
      setSalutation('');
      setPrivacyChecked(false);
      (e.target as HTMLFormElement).reset();
      setIsEmailSent(true); 
    } catch (err) {
    }
  };

  return (
    <SinglePage
      title="Kontakt"
      heroBanner={
        <HeroBanner
          imageSource={require('../../../assets/images/Contact/2025_rtb_1.jpg')}
          headline="KONTAKT."
          text="Du hast Fragen oder möchtest etwas loswerden? Dann kontaktiere uns gerne."
          onNextSection={scrollToTopicIntro}
        />
      }
      topic={
        isEmailSent ? (
          <></>
        ) : (
          <div ref={topicIntroRef}>
            <TopicIntro
              headline="KONTAKT."
              introductionText={<span>Du hast Fragen oder möchtest mehr über die Eckenmoorhexen erfahren? Dann kontaktiere uns! Ob du neugierig auf unsere Geschichte, Traditionen und Bräuche bist oder selbst Teil unserer Gemeinschaft werden möchtest – wir freuen uns, von dir zu hören. <br/> <br/> Du möchtest Mitglied der Eckenmoorhexen werden? Dann bewirb dich! <HighlightLink as={Link} to='/bewerbung'>Klicke hier</HighlightLink> um mehr zu erfahren!</span>}
            />
          </div >
        )
      }
      content={
        isEmailSent ? (
          <MessageConfirmed />
        ) : (
          <>
            <form className="contact-form" onSubmit={sendEmail}>
              <Container>
                <ColumnsWrapper>
                  <Column>
                    <StyledFormControl>
                      <StyledInputLabel htmlFor="salutation" required>Anrede</StyledInputLabel>
                      <StyledSelect
                        labelId="salutation-label"
                        id="salutation"
                        value={salutation}
                        label="Anrede"
                        onChange={handleSalutationChange}
                        name="salutation"
                      >
                        <StyledMenuItem value="Frau">Frau</StyledMenuItem>
                        <StyledMenuItem value="Herr">Herr</StyledMenuItem>
                        <StyledMenuItem value="Divers">Divers</StyledMenuItem>
                      </StyledSelect>
                    </StyledFormControl>
                    <StyledTextField label="Vorname" variant="outlined" name="surName" required />
                    <StyledTextField label="Nachname" variant="outlined" name="lastName" required />
                  </Column>
                  <Column>
                    <StyledTextField label="Betreff" variant="outlined" name="subject" required />
                    <StyledTextField label="E-mail" variant="outlined" type="email" name="mail" required />
                    <StyledTextField label="Telefon" variant="outlined" name="phone" />
                  </Column>
                </ColumnsWrapper>
                <StyledMultilineTextField label="Nachricht" variant="outlined" rows={4} multiline name="message" required />
                <StyledFormControlLabel
                  control={<Checkbox name="privacy" id='privacy' checked={privacyChecked} onChange={handlePrivacyChange} />}
                  label="Ich habe die Datenschutzbestimmungen gelesen und akzeptiere sie."
                  required
                />
                <SubmitInput value="Nachricht senden" />
              </Container>
            </form>
          </>
        )
      }
    />
  );
};

export default Contact;
